import { Injectable } from '@angular/core';
import { NotificationService } from '@app/shared/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { RootStoreState } from '..';
import * as notificationActions from './actions';

@Injectable()
export class NotificationStoreEffects {
  notificationObject = this.store$.select('Notification');

  constructor(private actions$: Actions, private notificationService: NotificationService, private store$: Store<RootStoreState.State>) {}

  getUserNotificationsEffect$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType<notificationActions.NotificationsRequestAction>(notificationActions.ActionTypes.NOTIFICATIONS_REQUEST),
      withLatestFrom(this.store$),
      switchMap(([action, storeState]) => {
        return this.notificationService.getAllNotifications(action.payload).then((notifications) => {
          let updatableNotifications = JSON.parse(JSON.stringify(storeState.Notification.notifications));
          const newNotifications = Array.from(notifications['data']?.reverse());

          if (newNotifications.length > 0) {
            if (action.payload.notificationId) {
              // response only includes delta data.
              if (updatableNotifications == null) {
                updatableNotifications = newNotifications; //there was no existing data
              } else {
                updatableNotifications = newNotifications.concat(updatableNotifications); //append new notifications
              }
            } else {
              updatableNotifications = newNotifications; //get full request data
            }
          }
          // reset redux store if notifications array is empty
          else {
            updatableNotifications = newNotifications;
          }
          return new notificationActions.NotificationsAction(updatableNotifications);
        });

        // return this.notificationService.getAllNotifications(action.payload).pipe(
        //   map((notifications) => {
        //     // let updatableNotifications = JSON.parse(JSON.stringify(storeState.Notification.notifications));
        //     // const newNotifications = Array.from(notifications.data);

        //     // if (newNotifications.length > 0) {
        //     //   if (action.payload.notificationId) {
        //     //     // response only includes delta data.
        //     //     if (updatableNotifications == null) {
        //     //       updatableNotifications = newNotifications; //there was no existing data
        //     //     } else {
        //     //       updatableNotifications = newNotifications.concat(updatableNotifications); //append new notifications
        //     //     }
        //     //   } else {
        //     //     updatableNotifications = newNotifications; //get full request data
        //     //   }
        //     // }
        //     // // reset redux store if notifications array is empty
        //     // else {
        //     //   updatableNotifications = newNotifications;
        //     // }

        //     console.log("**");
        //     return new notificationActions.NotificationsAction([]);
        //   }),
        // catchError((error) => {
        //   return observableOf(new notificationActions.NotificationsRequestFailureAction({ error }));
        // })
        // );
      })
    )
  );

  markAsReadEffect$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType<notificationActions.MarkAsReadAction>(notificationActions.ActionTypes.MARK_AS_READ),
      withLatestFrom(this.store$),
      switchMap(([action, storeState]) => {
        return this.notificationService.userNotificationUpdate({ id: action.payload }).pipe(
          map(() => {
            const updatableNotifications = JSON.parse(JSON.stringify(storeState.Notification.notifications));
            updatableNotifications.filter((n) => n.id == action.payload)[0].is_read = true;
            updatableNotifications.filter((n) => n.id == action.payload)[0].updated_at = new Date(Date.now()).toUTCString();
            return new notificationActions.NotificationsAction(updatableNotifications);
          }),
          catchError((error) => {
            return observableOf(new notificationActions.MarkAsReadFailureAction({ error }));
          })
        );
      })
    )
  );
}
